module.exports = __webpack_public_path__ + "img/scroll3.fa084bf9.png";